module.exports = __webpack_public_path__ + "media/images/emblems/Coa_Switzerland_Town_Waldenburg-1979be8e0433f970ce4d9b56b8856f19.svg";